import React from "react";
import { useQuery } from "convex/react";
import { Link } from "react-router-dom";

function GalleryPage2() {
  const images = useQuery("gallery:get") || [];
  const page2Images = images.slice(12, 24);

  return (
    <>
      <div className="grid grid-cols-3 gap-7 md1000:grid-cols-2 min540:grid-cols-1">
        {page2Images.map((img) => (
          <div key={img._id}>
            <img alt="gallery_img" className="w-full h-[25rem] object-cover rounded-lg shadow-md" src={img.url} />
          </div>
        ))}
      </div>

      <div className="flex justify-center gap-3 mt-32">
        <Link
          onClick={() => window.top(0, 0)}
          to="/gallery/page-1"
          className="text-black inline-flex items-center justify-center text-center text-[18px] border border-solid border-[#dee2e6] w-[48px] h-[45px] font-medium rounded-md bg-white "
        >
          <i className="fa-solid fa-angles-left"></i>
        </Link>
        <Link
          onClick={() => window.top(0, 0)}
          to="/gallery/page-1"
          className="text-black inline-flex items-center justify-center text-center text-[18px] border border-solid border-[#dee2e6] w-[48px] h-[45px] font-medium rounded-md  bg-white"
        >
          1
        </Link>
        <Link
          onClick={() => window.top(0, 0)}
          to="/gallery/page-2"
          className="text-white inline-flex items-center justify-center text-center text-[18px] border border-solid border-[#dee2e6] w-[48px] h-[45px] font-medium rounded-md bg-[#ff0336] "
        >
          2
        </Link>
      </div>
    </>
  );
}

export default GalleryPage2;
